import store from "@/store";
import { NavigationGuardNext, Route } from "vue-router";

export default async (to: Route, from: Route, next: NavigationGuardNext) => {
  // Obtenemos el status de la sesión del usuario
  let isAuthenticated = store.getters["auth/isAuthenticated"];
  if (isAuthenticated) {
    let role = store.getters["auth/role"];
    let rol = store.getters["auth/rol"];
    // La aplicación maneja ROLES para el acceso a los módulos
    // la sesión nos indica los roles a los
    // que pertenece el usuario y se valida sobre los roles
    // requeridos para tener acceso al módulo en cuestión.
    //
    // Los roles requeridos se encuentran en
    //    to.meta.allow[]  --> Lista de roles que tienen acceso
    //    to.meta.deny[]  --> Lista de roles que no tiene acceso
    //

    let { allow = ["*"], deny = [] } = to.meta;
    // Validamos si el role del usuario actual está considerado
    // dentro de los roles que tienen acceso al módulo
    let isAllow = allow.find((r: string) => r === "*" || r === role);
    // Validamos si el role del usuario actual está considerado
    // dentro de los roles que no tienen acceso al módulo
    let isDeny = deny.find((r: string) => r === "*" || r === role || r === rol);
    // Validación de autorizadoes
    let rolesAutorizadores = ["1", "2", "4", "5"]; // Autorizador, Admin y usuario Subcontratacion
    let isAutorizador = rolesAutorizadores.find((r: string) => r === rol);
    if (!isAllow || isDeny) {
      if (typeof isAutorizador !== undefined) {
        // Se tiene el rol de autorizador por
        // lo que solo tiene acceso al modulo de autorizar
        next("/inicio");
        return false;
      } else {
        // El role no tiene acceso al módulo solicitado, por lo que
        // no se le permite el acceso y se redirecciona a la pantalla
        // de forbidden
        next("/forbidden");
        return false;
      }
    }
  } else {
    next({ name: "signin" });
    return false;
  }
};
